import { Accordion, AccordionData, DangerousHTML, Typography } from '@/shared/ui';

import { trackFaqAccordionOpen } from '@/loader/trackFaqAccordionOpen';

import { FAQ } from '@/api/types';

import './Faq.scss';

interface Props {
  faqData: FAQ[];
}

export const Faq: React.FC<Props> = ({ faqData }) => {
  const accordionData: AccordionData[] = faqData.map((item) => ({
    label: <Typography variant="H4">{item.question}</Typography>,
    children: <DangerousHTML content={item.answer} />,
    className: 'faq__item',
  }));

  return (
    <div className="container">
      <div className="faq">
        <Typography variant="H1" className="faq-title">
          Поширені питання та відповіді
        </Typography>
        <Accordion
          items={accordionData}
          className="faq-accordion"
          onChange={(key): void => (key[0] ? trackFaqAccordionOpen(faqData[Number(key[0])].question) : undefined)}
        />
      </div>
    </div>
  );
};
